// Quests adicionadas em 14/10/2026: as grandes de história (Yalahar, Koshei, Children of the Revolution, Forgotten
// Knowledge, Cults of Tibia, Ferumbras' Ascension, Heart of Destruction, Soul War, The First Dragon) e as pequenas de baú.
// Gerado de tools/maps/quests_extra.json (recompensas finais oficiais: scripts e baús do Canary).
export const EXTRA_QUESTS: Array<{ id: string; name: string; level: number; maxPlayers: number; desc: string;
  r: { choose?: Array<[number, number]>; all?: Array<[number, number]>; gold?: number; random?: boolean } }> = [
 {
  "id": "yalahar",
  "name": "In Service of Yalahar",
  "level": 80,
  "maxPlayers": 5,
  "desc": "Trabalhe para os Yalahari e atravesse os bairros da cidade: o dos Alquimistas tomado por mutantes e pelo trio doente, o Submerso dos quaras e a Fábrica dos golems de guerra, até a batalha final na torre de Azerus. No fim, escolha uma peça do equipamento Yalahari.",
  "r": {
   "choose": [
    [
     8862,
     1
    ],
    [
     8863,
     1
    ],
    [
     8864,
     1
    ],
    [
     50289,
     1
    ]
   ]
  }
 },
 {
  "id": "koshei",
  "name": "Koshei the Deathless",
  "level": 60,
  "maxPlayers": 4,
  "desc": "Junte as quatro partes do amuleto perdido de Koshei, explore as ruínas da torre dele ao sul de Darashia e desça à cripta onde o necromante imortal espera. Devolva o amuleto e abra a câmara do tesouro.",
  "r": {
   "all": [
    [
     645,
     1
    ]
   ],
   "gold": 10100
  }
 },
 {
  "id": "children-revolution",
  "name": "Children of the Revolution",
  "level": 70,
  "maxPlayers": 4,
  "desc": "Ajude Zalamon e a resistência dos lagartos em Zao: atravesse as Planícies Muggy, espione a fortaleza do Imperador, desvende o Caminho das Pedras e enfrente o Exército Fantasma. Zalamon entrega a crista da serpente como sinal de respeito.",
  "r": {
   "all": [
    [
     10199,
     1
    ]
   ]
  }
 },
 {
  "id": "forgotten-knowledge",
  "name": "Forgotten Knowledge",
  "level": 250,
  "maxPlayers": 5,
  "desc": "Ajude a recuperar o conhecimento perdido: enfrente Lloyd, Lady Tenebris, o Thorn Knight, o Frozen Horror e a alma do Dragonking Zyrtarch, até o Time Guardian e o Last Lore Keeper. As partes de runa dos chefes se unem na Astral Shaper Rune.",
  "r": {
   "all": [
    [
     24960,
     1
    ]
   ]
  }
 },
 {
  "id": "cults",
  "name": "Cults of Tibia",
  "level": 200,
  "maxPlayers": 5,
  "desc": "Investigue para Gerimor os cultos secretos espalhados pelo mundo: minotauros adoradores de ídolos, orcs do vazio, Barkless e os enganados, até chegar à Essência da Malícia. Ganhe uma coroa de vocação e uma caixa misteriosa.",
  "r": {
   "choose": [
    [
     26190,
     1
    ],
    [
     26187,
     1
    ],
    [
     26189,
     1
    ],
    [
     26188,
     1
    ]
   ],
   "all": [
    [
     26186,
     1
    ]
   ]
  }
 },
 {
  "id": "ferumbras",
  "name": "Ferumbras' Ascension",
  "level": 350,
  "maxPlayers": 5,
  "desc": "Impeça a ascensão de Ferumbras na sua cidadela: derrote os oito arquidemônios que guardam os selos (Ragiaz, Razzagorn, Zamulosh, Tarbaz, Plagirath, Shulgrax e Mazoran) e enfrente o Ascending Ferumbras no trono.",
  "r": {
   "all": [
    [
     22731,
     4
    ],
    [
     22737,
     4
    ],
    [
     22775,
     1
    ],
    [
     22516,
     5
    ]
   ],
   "gold": 100000
  }
 },
 {
  "id": "heart-destruction",
  "name": "Heart of Destruction",
  "level": 300,
  "maxPlayers": 5,
  "desc": "Atravesse a fenda até o Coração da Destruição: domine a Anomalia, a Ruptura, o Erradicador e a Explosão, e destrua o World Devourer antes que ele consuma tudo.",
  "r": {
   "all": [
    [
     23512,
     1
    ],
    [
     23538,
     1
    ],
    [
     23536,
     1
    ],
    [
     23509,
     1
    ],
    [
     22721,
     5
    ]
   ],
   "gold": 200000
  }
 },
 {
  "id": "soul-war",
  "name": "Soul War",
  "level": 400,
  "maxPlayers": 5,
  "desc": "Enfrente os fragmentos da alma de Goshnar espalhados pelas terras do Soul War: Spite, Greed, Malice, Hatred e Cruelty, até o Goshnar's Megalomania. No Tibia o baú final dá um item Soul aleatório; aqui você escolhe um.",
  "r": {
   "random": true,
   "choose": [
    [
     34082,
     1
    ],
    [
     34083,
     1
    ],
    [
     34084,
     1
    ],
    [
     34085,
     1
    ],
    [
     34086,
     1
    ],
    [
     34087,
     1
    ],
    [
     34088,
     1
    ],
    [
     34089,
     1
    ],
    [
     34090,
     1
    ],
    [
     34091,
     1
    ],
    [
     34092,
     1
    ],
    [
     34093,
     1
    ],
    [
     34094,
     1
    ],
    [
     34095,
     1
    ],
    [
     34096,
     1
    ],
    [
     34097,
     1
    ],
    [
     34098,
     1
    ],
    [
     34099,
     1
    ]
   ]
  }
 },
 {
  "id": "first-dragon",
  "name": "The First Dragon",
  "level": 200,
  "maxPlayers": 5,
  "desc": "Siga a trilha dos quatro grandes dragões, Tazhadur, Kalyassa, Gelidrazah e Zorvorax, até o covil do Primeiro Dragão. Os baús finais guardam a máscara de porcelana, penas coloridas e uma mochila de tesouros.",
  "r": {
   "all": [
    [
     25088,
     1
    ],
    [
     25089,
     3
    ],
    [
     24390,
     1
    ],
    [
     11658,
     1
    ],
    [
     21801,
     2
    ],
    [
     9660,
     2
    ],
    [
     22721,
     3
    ],
    [
     3041,
     1
    ],
    [
     3037,
     1
    ],
    [
     3039,
     1
    ],
    [
     5954,
     2
    ],
    [
     21194,
     2
    ],
    [
     23508,
     2
    ],
    [
     10420,
     2
    ],
    [
     11703,
     2
    ],
    [
     14012,
     2
    ],
    [
     9665,
     2
    ],
    [
     10304,
     2
    ]
   ]
  }
 },
 {
  "id": "wedding-ring",
  "name": "Wedding Ring Quest",
  "level": 60,
  "maxPlayers": 4,
  "desc": "Nas profundezas sob Edron, além da Hero Cave, dois baús antigos guardam um Dragon Necklace e um Wedding Ring.",
  "r": {
   "all": [
    [
     3085,
     1
    ],
    [
     3004,
     1
    ]
   ]
  }
 },
 {
  "id": "skull-ratha",
  "name": "Skull of Ratha Quest",
  "level": 20,
  "maxPlayers": 4,
  "desc": "No alto de uma velha torre, a leste de Kazordoon, alguém escondeu a caveira de Ratha junto com uma pérola e duas joias.",
  "r": {
   "all": [
    [
     3207,
     1
    ],
    [
     3026,
     1
    ],
    [
     3012,
     1
    ],
    [
     3097,
     1
    ]
   ]
  }
 },
 {
  "id": "poison-daggers",
  "name": "Poison Daggers Quest",
  "level": 20,
  "maxPlayers": 4,
  "desc": "Nas cavernas ao sul de Edron, entre mortos-vivos e vermes, uma mochila esquecida guarda Poison Daggers e flechas envenenadas.",
  "r": {
   "all": [
    [
     3299,
     1
    ],
    [
     3448,
     30
    ]
   ]
  }
 },
 {
  "id": "shaman-treasure",
  "name": "Shaman Treasure Quest",
  "level": 12,
  "maxPlayers": 4,
  "desc": "Os orcs de Edron guardam o tesouro do seu xamã: um saco de runas em branco.",
  "r": {
   "all": [
    [
     3147,
     3
    ]
   ]
  }
 },
 {
  "id": "ornamented-shield",
  "name": "Ornamented Shield Quest",
  "level": 40,
  "maxPlayers": 4,
  "desc": "Sob as ruínas a leste de Thais, mortos-vivos guardam dois baús: um com o Ornamented Shield e armas, outro com joias, um spellbook e um Time Ring.",
  "r": {
   "all": [
    [
     3424,
     1
    ],
    [
     3351,
     1
    ],
    [
     3271,
     1
    ],
    [
     3085,
     1
    ],
    [
     3048,
     1
    ],
    [
     3059,
     1
    ],
    [
     3083,
     1
    ],
    [
     3053,
     1
    ],
    [
     2949,
     1
    ],
    [
     3509,
     1
    ]
   ],
   "gold": 500
  }
 },
 {
  "id": "parchment-room",
  "name": "Parchment Room Quest",
  "level": 100,
  "maxPlayers": 4,
  "desc": "Nas profundezas de Edron, um pergaminho sela uma sala: \"Enterrado para sempre, que ele nunca retorne\". Retire o selo e enfrente os quatro demônios libertados.",
  "r": {
   "all": [
    [
     3049,
     1
    ],
    [
     3034,
     2
    ]
   ]
  }
 },
 {
  "id": "giant-smithhammer",
  "name": "Giant Smithhammer Quest",
  "level": 30,
  "maxPlayers": 4,
  "desc": "Na forja abandonada dos ciclopes, a leste de Thais, uma alavanca abre o caminho para o Giant Smithhammer.",
  "r": {
   "all": [
    [
     3208,
     1
    ],
    [
     3034,
     1
    ]
   ],
   "gold": 100
  }
 },
 {
  "id": "adorned-uh",
  "name": "Adorned UH Rune Quest",
  "level": 60,
  "maxPlayers": 4,
  "desc": "No fundo das cavernas de Edron, entre heróis caídos e liches, um baú guarda o emblema de runa de prata da Ultimate Healing.",
  "r": {
   "all": [
    [
     11603,
     1
    ]
   ]
  }
 },
 {
  "id": "explorer-brooch",
  "name": "Explorer Brooch Quest",
  "level": 20,
  "maxPlayers": 4,
  "desc": "Para a Explorer Society, desça às minas sob Kazordoon e encontre o Explorer Brooch perdido entre os anões.",
  "r": {
   "all": [
    [
     4871,
     1
    ]
   ]
  }
 },
 {
  "id": "strong-potions",
  "name": "Strong Potions Quest",
  "level": 60,
  "maxPlayers": 4,
  "desc": "Num canto esquecido das profundezas de Edron, um saco verde guarda dois Silver Tokens, deixados por um antigo mestre do imbuement.",
  "r": {
   "all": [
    [
     22516,
     2
    ]
   ]
  }
 },
 {
  "id": "edron-goblin",
  "name": "Edron Goblin Quest",
  "level": 10,
  "maxPlayers": 4,
  "desc": "Os goblins das cavernas de Edron esconderam dois baús: um Silver Amulet e um Steel Shield.",
  "r": {
   "all": [
    [
     3054,
     1
    ],
    [
     3409,
     1
    ]
   ]
  }
 },
 {
  "id": "orc-shaman",
  "name": "Orc Shaman Quest",
  "level": 20,
  "maxPlayers": 4,
  "desc": "Na caverna dos orcs ao sul de Edron, o saco do xamã guarda uma Magic Light Wand, um Axe Ring e uma runa em branco.",
  "r": {
   "all": [
    [
     3046,
     1
    ],
    [
     3092,
     1
    ],
    [
     3147,
     1
    ]
   ]
  }
 },
 {
  "id": "witch-house",
  "name": "Witch House Quest",
  "level": 15,
  "maxPlayers": 4,
  "desc": "A casa da bruxa nas colinas guarda pérolas negras, um Crystal Necklace e algumas moedas.",
  "r": {
   "all": [
    [
     3027,
     2
    ],
    [
     3008,
     1
    ]
   ],
   "gold": 100
  }
 },
 {
  "id": "geomancer",
  "name": "Geomancer Quest",
  "level": 20,
  "maxPlayers": 4,
  "desc": "Nas minas dos anões, os geomantes guardam um saco com safira, diamante e um Dwarven Ring.",
  "r": {
   "all": [
    [
     3029,
     1
    ],
    [
     3028,
     1
    ],
    [
     3097,
     1
    ]
   ]
  }
 },
 {
  "id": "deeper-fibula",
  "name": "Deeper Fibula Quest",
  "level": 30,
  "maxPlayers": 4,
  "desc": "Bem abaixo de Fibula, os minotauros dominam as cavernas onde cinco baús guardam escudo, elmo, anel, amuleto e machado.",
  "r": {
   "all": [
    [
     3428,
     1
    ],
    [
     3369,
     1
    ],
    [
     3097,
     1
    ],
    [
     3082,
     1
    ],
    [
     3318,
     1
    ]
   ]
  }
 },
 {
  "id": "devil-helmet",
  "name": "Devil Helmet Quest",
  "level": 35,
  "maxPlayers": 4,
  "desc": "Pelos esgotos de Thais até Mintwallin, a cidade dos minotauros, onde o Devil Helmet e uma alabarda esperam no fundo.",
  "r": {
   "all": [
    [
     3356,
     1
    ],
    [
     3269,
     1
    ],
    [
     3029,
     4
    ]
   ]
  }
 },
 {
  "id": "desert-quest",
  "name": "Desert Quest",
  "level": 25,
  "maxPlayers": 4,
  "desc": "No calabouço do deserto, um cavaleiro, um paladino, um druida e um feiticeiro precisam puxar juntos as alavancas para chegar aos baús.",
  "r": {
   "all": [
    [
     3084,
     1
    ],
    [
     3098,
     1
    ],
    [
     3046,
     1
    ],
    [
     3077,
     1
    ]
   ],
   "gold": 10000
  }
 },
 {
  "id": "demona-ring",
  "name": "Demona Ring Quest",
  "level": 50,
  "maxPlayers": 4,
  "desc": "Nas profundezas de Demona, entre gárgulas e golems de pedra, dois baús guardam um Stealth Ring e um Energy Ring.",
  "r": {
   "all": [
    [
     3049,
     1
    ],
    [
     3051,
     1
    ]
   ]
  }
 },
 {
  "id": "darashia-dragon",
  "name": "Darashia Dragon Quest",
  "level": 40,
  "maxPlayers": 4,
  "desc": "No covil dos dragões sob Darashia, um Life Ring está perdido entre ossos e ninhos.",
  "r": {
   "all": [
    [
     3052,
     1
    ]
   ]
  }
 },
 {
  "id": "lone-medusa",
  "name": "Lone Medusa Quest",
  "level": 80,
  "maxPlayers": 4,
  "desc": "Numa ilha isolada vive uma Medusa solitária. Vença as serpentes e ela, e leve as quatro pérolas negras do seu esconderijo.",
  "r": {
   "all": [
    [
     3027,
     4
    ]
   ]
  }
 },
 {
  "id": "waterfall",
  "name": "Waterfall Quest",
  "level": 30,
  "maxPlayers": 4,
  "desc": "Atrás de uma cachoeira em Tiquanda, piratas esconderam uma mochila com um Pirate Hat e um Dwarven Ring.",
  "r": {
   "all": [
    [
     6096,
     1
    ],
    [
     3097,
     1
    ]
   ]
  }
 }
];
